import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dcbd9b8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  "data-id": "contact",
  class: "contact-section"
}
const _hoisted_2 = { class: "section-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-title" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Contact")
], -1))
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-xs-12 col-sm-4" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "lm-info-block-value" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "lm-info-block-text" }, null, -1))
const _hoisted_8 = { class: "col-xs-12 col-sm-8" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block-title" }, [
  /*#__PURE__*/_createElementVNode("h3", null, [
    /*#__PURE__*/_createTextVNode("How Can I "),
    /*#__PURE__*/_createElementVNode("span", null, "Help You?")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContactForm = _resolveComponent("ContactForm")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contactInfo, (cinfo) => {
            return (_openBlock(), _createElementBlock("div", {
              key: cinfo.id,
              class: "lm-info-block gray-default"
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(cinfo.icon)
              }, null, 2),
              _createElementVNode("h4", null, _toDisplayString(cinfo.info), 1),
              _hoisted_6,
              _hoisted_7
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode(_component_ContactForm)
        ])
      ])
    ])
  ]))
}